/* eslint-disable camelcase */
/*
This divides any sum into parts and distributes the remainder
So if you want to divide 100% by 3 people you do
divideSumIntoEqualParts(3,100);

and it returns [34, 33, 33]
*/
export const divideSumIntoEqualParts = (parts: number, sum = 100) => {
  if (parts === 0) {
    return [];
  }

  const generateEqualParts = () => {
    const unit = 100 / parts;
    const result = [];

    for (let i = 0; i < parts; i += 1) {
      result.push(unit);
    }

    return result;
  };

  const getLargestRemainder = (values: number[], desiredSum: number) => {
    let s = 0;
    let valueParts = values.map((value, index) => {
      const integerValue = value | 0;
      s += integerValue;
      return {
        integer: integerValue,
        decimal: value % 1,
        originalIndex: index,
      };
    });

    if (s !== desiredSum) {
      // Sort values by decimal part
      valueParts = valueParts.sort((x) => x.decimal);

      const diff = desiredSum - s;
      let i = 0;

      // Distribute the difference.
      while (i < diff) {
        valueParts[i].integer += 1;
        i += 1;
      }
    }

    return valueParts.sort((x) => x.originalIndex).map((p) => p.integer);
  };

  return getLargestRemainder(generateEqualParts(), sum);
};

export const customFloor = (value: number, roundTo: number) => {
  return Math.floor(value / roundTo) * roundTo;
};

export const calculateAdvancedSwapPrice = (start: number, end: number, total: number, left: number, slippage = 0) => {
  const price_adj_per_collect = (end - start) / Math.max(1, total - 1);
  const current = start + (total - left) * price_adj_per_collect;
  return Math.min(end, current + price_adj_per_collect * slippage);
};
